export const FEEDBACK_CONTEXT_CUSTOM_FIELD = 'customfield_10047';

export const LINKED_ISSUES_BUTTON = 'feedback-renderer.linked-issues-btn';
